import { stores as sampleStores } from './sample';
import { stores as O10g015460Stores } from './o10g015460';
import { stores as O10g014111Stores } from './o10g014111';
import { stores as O10g014112Stores } from './o10g014112';
import { DialogStore } from "@posco/posco-ui-react";

export default {
  ...sampleStores,
  ...O10g015460Stores,
  ...O10g014111Stores,
  ...O10g014112Stores,
  mesDialogStore: DialogStore.instance,
};
